import { makeStyles } from '@mui/styles';

const useGalleryStyle = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    zIndex: 2,
    width: '100%',
    fontSize: 'max(3vw, 30px) !important',
    fontWeight: 'bolder !important',
    marginTop: '80px !important',
    fontFamily: 'Lato !important',
  },
  text: {
    fontSize: '1.5rem !important',
    zIndex: 2,
  },
  gallery: {
    margin: 'auto',
    padding: 0,
    width: '100%',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, 300px)',
    gridAutoRows: '10px',
    justifyContent: 'center',
  },
});

export default useGalleryStyle;
